'use strict';

module.exports = require('client_core/components/menu');

// Copied from autobahn_core to restore link behavior for account icon in mobile
module.exports.dropdownMenu = function () {
  var ns = '.custom-dropdown-action ';
  // Custom dropdown behaviors for top menu
  var $document = $(document);
  var $dropdownMenu = $('[data-toggle="menu"], [data-toggle="dropdown"]', '.custom-dropdown:not(.disabled)').off(ns);
  $dropdownMenu.on('click' + ns, function (event) {
    if (!window.isMobile() || event.target.id === 'dropdownAccountSelector') return;
    var $dropdownLink = $(event.target).closest('[data-toggle="menu"]');
    $dropdownLink = $dropdownLink.length === 0 ? $(event.target) : $dropdownLink;
    var $dropdown = $dropdownLink.closest('.custom-dropdown');

    // Drawer behavior on mobile
    event.preventDefault();
    var $li = $('<li class="dropdown-item top-category" role="button"></li>');
    var $closeMenu = $('<li class="nav-menu"></li>');
    var link = $dropdownLink.clone().removeClass('dropdown-toggle').removeAttr('data-toggle').removeAttr('aria-expanded').attr('aria-haspopup', 'false');
    $li.append(link);
    $closeMenu.append($('.close-menu').first().clone());
    $dropdown.children('.dropdown-menu').prepend($li).prepend($closeMenu).attr('aria-hidden', 'false').find('a').removeAttr('tabindex', '-1');
    $dropdown.addClass('show');
    $dropdownLink.attr('aria-expanded', 'true');
    $dropdown.closest('.menu-group').find('.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
    $(link).focus();
    $('.dropdown-menu').scrollTop(0);
  });

  // Desktop - open menu using hoverIntent to prevent unintentional opening
  $dropdownMenu.on('mouseover' + ns, function (event) {
    if (!window.isMobile()) {
      var eventElement = event.target,
        $eventElement = $(eventElement);
      clearTimeout($document.data('hovertimeout'));
      $document.data('hovertimeout', setTimeout(function () {
        // Close all dropdowns
        $('.navbar-nav > li').each(function (index, element) {
          if (!$.contains(element, eventElement)) {
            var $navItem = $(element);
            $navItem.find('.show').each(function () {
              module.exports.clearSelection(element);
            });
            if ($navItem.hasClass('show')) {
              $navItem.removeClass('show');
              $navItem.children('ul.dropdown-menu').removeClass('show');
              $navItem.children('.nav-link').attr('aria-expanded', 'false');
            }
          }
        });
        // Close any open modals
        $('.modal').modal('hide');
        // Open current dropdown
        $eventElement.parent().addClass('show');
        $eventElement.siblings('.dropdown-menu').addClass('show').attr('aria-hidden', 'false');
        $eventElement.attr('aria-expanded', 'true');
      }, 50)); // Delay to prevent unintentional menu opening
    }
  });

  // Desktop - close menu on mouseleave of dropdown container
  $document.on('mouseleave' + ns, '.custom-dropdown:not(.disabled)', function (event) {
    if (!window.isMobile()) {
      clearTimeout($document.data('hovertimeout'));
      var $dropdown = $(event.currentTarget).closest('.custom-dropdown');
      // Close current dropdown
      $dropdown.removeClass('show');
      $dropdown.children('.dropdown-menu').removeClass('show').attr('aria-hidden', 'true');
      $dropdown.children('.nav-link').attr('aria-expanded', 'false');
    }
  });
};
module.exports.applyMenuListeners = function () {
  $(document).on('loadFullMenu', function (event) {
    return module.exports.dropdownMenu();
  });
};